import { Roles } from '@client/graphql/__generated__/types';
import { useAppContext } from '~/services/main/contexts/AppContext';

/**
 * Whether the signed-in user is Indigo-internal (global ADMIN or EMPLOYEE
 * role) — the same check the internal app's routes use to gate access.
 */
export const useIsInternalEmployee = (): boolean => {
  const { user } = useAppContext();

  return Boolean(
    user?.roles.includes(Roles.ADMIN) || user?.roles.includes(Roles.EMPLOYEE)
  );
};
